let cachedSearchText: string | null = null;
let cachedHighlightRegex: RegExp | null = null;

export function highlightSearchText(searchText: string, text: string): string {
    if (!text || !searchText) {
        return text;
    }

    if (searchText !== cachedSearchText) {
        cachedSearchText = searchText;
        const keywords = searchText.split(' ').filter(word => word.length > 0);
        if (keywords.length === 0) {
            cachedHighlightRegex = null;
        } else {
            const escapedKeywords = keywords.map(word =>
                word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
            );
            cachedHighlightRegex = new RegExp(`(${escapedKeywords.join('|')})`, "gi");
        }
    }

    if (!cachedHighlightRegex) {
        return text;
    }
    return text.replace(cachedHighlightRegex, "<span class='searchedText'>$1</span>");
}

export function highlightFileSearchText(searchText: string, text: string): string {
    if (!text || !searchText) {
        return text;
    }

    const keywords = searchText
        .trim()
        .split(/\s+/)
        .filter(Boolean);

    if (keywords.length === 0) {
        return text;
    }

    const escapedKeywords = keywords.map(word =>
        word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    );
    const highlightRegex = new RegExp(`(${escapedKeywords.join('|')})`, "gi");

    return text.replace(highlightRegex, "<span class='searchedText'>$1</span>");
}

// Экранирует HTML-спецсимволы, чтобы текст можно было безопасно отрисовать через v-html
// (используется перед highlightSearchText для произвольного пользовательского текста).
export function escapeHtml(text: string): string {
    if (!text) {
        return text;
    }
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

// Убирает разметку подсветки из текста перед использованием его в логике
// (звонок/почта/ссылка/копирование). highlightSearchText оборачивает совпадения
// в <span class='searchedText'> с одинарными кавычками — именно это и зачищаем.
export function stripHighlightMarkup(text: string): string {
    if (!text) {
        return text;
    }
    return text
        .replace(/<span class='searchedText'>/g, '')
        .replace(/<\/span>/g, '');
}

// Принимает число и массив вариантов сопутствующих слов в разных склонениях
// Пример: (3, ['сообщение', 'сообщения', 'сообщений'])
export function declOfNum(number: number, titles: string[]): string {
    if (number === 0) {
        return titles[2];
    }

    const cases = [2, 0, 1, 1, 1, 2];
    return titles[
        (number % 100 > 4 && number % 100 < 20)
            ? 2
            : cases[(number % 10 < 5) ? number % 10 : 5]
        ];
}
